.content {
  overflow: hidden;
  flex-grow: 1;
  height: 100%;
  user-select: none;

  &.frozen {
    visibility: hidden;
  }
}

.resize {
  position: absolute;
  z-index: 1;
  right: -0.2rem;
  bottom: -0.2rem;
  width: 1rem;
  height: 1rem;
  padding: 0;
  cursor: nwse-resize;
  user-select: none;
  border: none;
  background: transparent;

  appearance: none;
}

.window {
  position: absolute;
  right: auto;
  bottom: auto;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  opacity: 0.9;
  color: inherit;
  border: 0.1rem solid black;
  border-radius: var(--radius-8);
  outline: none;

  .content {
    border-bottom-right-radius: var(--radius-8);
    border-bottom-left-radius: var(--radius-8);
  }
}

.active {
  opacity: 1;

  &.frozen {
    opacity: 0.8;
  }

  .content {
    user-select: inherit;
  }
}

.animated {
  transition-timing-function: ease-in-out;
  transition-duration: 0.2s;
  transition-property: height, left, opacity, top, width;
}

.minimized {
  opacity: 0;
}

@media only screen and (max-width: 1024px) {
  .window {
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
    border-radius: 0 !important;
  }
}
